(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logout', {
            parent: 'admin',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']
            },
            views: {
                'content@': {
                    controller: 'LogoutController',
                    controllerAs: 'vm'
                }
            },
        });
    }
})();
